import React, { useCallback } from "react";
import { useAppContext } from "@qlik/qlik/src/context/AppContext";
import mapButtonType from "@qlik/qlik/src/components/Cta/mapButtonType";
import { getSpacingClassName } from "@qlik/qlik/src/lib/util/spacing";
import { getColorClassName } from "@qlik/qlik/src/lib/util/colors";
import useIsMobileScreen from "@qlik/qlik/src/hooks/useIsMobileScreen";

/**
 * CardWithLinks component
 * @param {Object} data - The data for the CardWithLinks
 * @returns {JSX.Element} - The CardWithLinks component
 */

const CardWithLinks = ({ data }) => {
    const { cardItems = [], backgroundColor, additionalConfiguration, numberOfColumns, customId } = data ?? {};
    // Get the class name for the section padding
    const sectionSpacingClassName = getSpacingClassName(additionalConfiguration, "");
    const { sectionColorMapping } = getColorClassName(backgroundColor);
    const { headerHeight } = useAppContext();
    const isMobileScreen = useIsMobileScreen();

    // Function to handle smooth scroll with offset
    const handleScroll = useCallback(
        (event) => {
            event.preventDefault();
            const targetId = event.currentTarget.getAttribute("href").slice(1);
            const targetElement = document.getElementById(targetId);

            if (targetElement) {
                const headerOffset = isMobileScreen ? headerHeight : headerHeight - 40;
                const elementPosition = targetElement.getBoundingClientRect().top + window.scrollY;
                const offsetPosition = elementPosition - headerOffset;

                window.scrollTo({
                    top: offsetPosition,
                    behavior: "smooth",
                });
            }
        },
        [headerHeight, isMobileScreen]
    );

    return (
        <section className={`py-25 ${sectionSpacingClassName} ${sectionColorMapping.bgColor}`} id={customId}>
            <div className="container">
                <div
                    className={`grid ${
                        numberOfColumns === null
                            ? "md:grid-cols-3"
                            : `md:grid-cols-3 lg:grid-cols-${numberOfColumns || 3}`
                    } md:gap-x-7.5 md:gap-y-2.5 xl:px-30 xl:gap-x-17.5 xl:gap-y-2.5 `}
                >
                    {cardItems?.map((cardItem) => (
                        <div className="md:mb-5" key={cardItem.id}>
                            {cardItem?.cta?.map((link) => (
                                <div className="mb-5" key={link.id}>
                                    <a
                                        className={`${mapButtonType(link.type)}`}
                                        href={`#${link.externalUrl}`}
                                        onClick={handleScroll}
                                    >
                                        {link.text}
                                    </a>
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default CardWithLinks;
